import { RouteInfo } from './sidebar.metadata';

export const NEAR_MISS_ROUTES: RouteInfo[] = [
  {
    path: '/home',
    title: 'Home',
    icon: 'fas fa-clipboard-check',
    class: '',
    submenu: [],
    menuToggleOff: false,
  },
  {
    path: '/near-miss/near-misses',
    title: 'Near Misses',
    icon: 'fas fa-list',
    class: '',
    menuToggleOff: false,
    submenu: [],
  },
  {
    path: '/near-miss/tasks',
    title: 'Tasks',
    icon: 'fas fa-tasks',
    class: '',
    menuToggleOff: false,
    submenu: [],
  },
  {
    path: '/near-miss/settings',
    title: 'Settings',
    icon: 'fas fa-cog',
    class: 'menu-toggle',
    menuToggleOff: false,
    showMenu: '',
    submenu: [
      {
        path: '/near-miss/settings/locations',
        title: 'Locations',
        icon: 'fas fa-map-marker-alt',
        class: '',
        submenu: [],
      },
      {
        path: '/near-miss/settings/users',
        title: 'Users',
        icon: 'fas fa-user-friends',
        class: '',
        submenu: [],
      },
      {
        path: '/near-miss/settings/notifications',
        title: 'Notifications',
        icon: 'fas fa-bell',
        class: '',
        submenu: [],
      },
    ],
  },
  {
    path: 'help',
    title: 'Help',
    icon: 'fas fa-info-circle',
    class: 'menu-toggle',
    menuToggleOff: false,
    showMenu: '',
    submenu: [
      {
        path: "/authentication/help/Help Center",
        title: "Help Center",
        icon: "",
        class: "",
        submenu: [],
      },
      {
        path: "/authentication/help/Terms & Conditions",
        title: "Terms & Conditions",
        icon: "",
        class: "",
        submenu: [],
      },
      {
        path: "/authentication/help/Privacy Policy",
        title: "Privacy Policy",
        icon: "",
        class: "",
        submenu: [],
      },
    ],
  },
];

export const ROUTES: RouteInfo[] = [
  // {
  //     path: '/dashboard/main', title: 'Dashboard', icon: 'fas fa-home', class: '',
  //     submenu: []
  // },
  {
    path: '/home',
    title: 'Home',
    icon: 'fas fa-clipboard-check',
    class: '',
    submenu: [],
    menuToggleOff: false,
  },
  {
    path: '/create-new-audit',
    title: 'Start New Audit',
    icon: 'fas fa-check',
    class: '',
    menuToggleOff: false,
    showMenu: '',
    submenu: [
      {
        path: '/create-new-audit/questionnaire',
        title: 'Questionnaire',
        icon: 'fas fas fa-question',
        class: '',
        submenu: [],
      },
      {
        path: '/create-new-audit/signature',
        title: 'Comments & Signature',
        icon: 'fas fa-file-signature',
        class: '',
        submenu: [],
      },
      {
        path: '/create-new-audit/preview',
        title: 'Preview',
        icon: 'fas fa-eye',
        class: '',
        submenu: [],
      },
    ],
  },

  {
    path: '/create-new-incident/category',
    title: 'Log Incident',
    icon: 'fas fa-check',
    class: '',
    menuToggleOff: false,
    showMenu: '',
    submenu: [
      {
        path: '/create-new-incident/questionnaire',
        title: 'Questionnaire',
        icon: '',
        class: '',
        submenu: [],
      },
      {
        path: '/create-new-incident/incident-action',
        title: 'Action',
        icon: '',
        class: '',
        submenu: [],
      },
      {
        path: '/create-new-incident/signature',
        title: 'Signature',
        icon: '',
        class: '',
        submenu: [],
      },
      {
        path: '/create-new-incident/assign-submit',
        title: 'Assign & Submit',
        icon: '',
        class: '',
        submenu: [],
      },
    ],
  },

  {
    path: '/near-miss',
    title: 'Near Miss',
    icon: 'fas fa-exclamation-triangle',
    class: '',
    menuToggleOff: false,
    showMenu: '',
    submenu: [
      {
        path: '/near-miss/near-misses',
        title: 'Near Misses',
        icon: '',
        class: '',
        submenu: [],
      },
      {
        path: '/near-miss/tasks',
        title: 'Tasks',
        icon: '',
        class: '',
        submenu: [],
      },
      {
        path: '/near-miss/settings',
        title: 'Settings',
        icon: '',
        class: '',
        menuToggleOff: false,
        showMenu: '',
        submenu: [
          {
            path: '/near-miss/settings/locations',
            title: 'Locations',
            icon: '',
            class: '',
            submenu: [],
          },
          {
            path: '/near-miss/settings/users',
            title: 'Users',
            icon: 'fas fa-user-friends',
            class: '',
            submenu: [],
          },
          {
            path: '/near-miss/settings/notifications',
            title: 'Notifications',
            icon: '',
            class: '',
            submenu: [],
          },
        ],
      },
    ],
  },

  // {
  //     path: '/new-template', title: 'New Template', icon: 'fas fa-tachometer-alt', class: '',
  //     submenu: []
  // },
  // {
  //     path: '/import-audit', title: 'Import Audit', icon: 'fas fa-tachometer-alt', class: '',
  //     submenu: []
  // },
  {
    path: 'help',
    title: 'Help',
    icon: 'fas fa-info-circle',
    class: 'menu-toggle',
    menuToggleOff: false,
    showMenu: '',
    submenu: [
      {
        path: "/authentication/help/Help Center",
        title: "Help Center",
        icon: "",
        class: "",
        submenu: [],
      },
      {
        path: "/authentication/help/Terms & Conditions",
        title: "Terms & Conditions",
        icon: "",
        class: "",
        submenu: [],
      },
      {
        path: "/authentication/help/Privacy Policy",
        title: "Privacy Policy",
        icon: "",
        class: "",
        submenu: [],
      },
    ],
  },
  /* {
        path: '/tables/advance-table', title: 'Advance Table', icon: 'far fa-list-alt', class: '', submenu: []
    } */
];
